import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResetpasswordService } from '../../../common/services/resetpassword.service';
import { GlobalFunction } from '../../../common/core/global_function';
import { NotificationsService } from 'angular4-notifications';

@Component({
    selector: 'resetpassword',
    templateUrl: 'resetpassword.component.html',
})
export class ResetpasswordComponent {
    email_label = "";
    password_label = "";
    errorValue = "";
    sub: any;
    access_token: any;
    public loading = false;

    notifications_options: any = {
        timeOut: 3000,
        showProgressBar: false,
        pauseOnHover: true,
        clickToClose: true
    };

    constructor(private route: ActivatedRoute,
      private router: Router,
      public resetpassword_service: ResetpasswordService, public notification_service: NotificationsService) {
          var that = this;

        this.route.params.subscribe(params => {
          this.resetpassword_service.email = params['email'];
        });

    }

    ngOninit() {
        document.title="Reset Password";
    }
    redirect() {
      this.router.navigate(['/authenticate']);
    }

    message_close: any;
    resetPass() {
        var that = this;
        if (this.resetpassword_service.validate()) {
          this.resetpassword_service.resetPassword().then(rs => {
            // if(rs){
            //   console.log(rs);
            //   that.message_close.open({
            //     'title'     : 'Remind password',
            //     'content'   : 'Password has changed. Please login into the system.',
            //     'closeLabel': 'Close',
            //     'confirm'   : function() {
            //       that.resetpassword_service.email = '';
            //       that.resetpassword_service.temporary_password = '';
            //       that.resetpassword_service.new_password = '';
            //       that.resetpassword_service.confirm_password = '';
            //       that.redirect();
            //     }
            //   });
            // }
            that.message_close.open({
              'title'     : 'Remind password',
              'content'   : 'Password has changed. Please login into the system.',
              'closeLabel': 'Close',
              'confirm'   : function() {
                that.resetpassword_service.email = '';
                that.resetpassword_service.temporary_password = '';
                that.resetpassword_service.new_password = '';
                that.resetpassword_service.confirm_password = '';
                that.redirect();
              }
            });
          });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/application/authenticate/resetpassword/resetpassword.component.ts